import ApiClient from './ApiClient';
import PolicyExemptionRequest from '../models/entities/PolicyExemptionRequest';
import SubmitPolicyExemptionRequest from '../models/viewModels/PolicyExemptionRequests/SubmitPolicyExemptionRequest';


export default class PolicyExemptionRequestService extends ApiClient {

	async getById(id: number) {
		return this.get<PolicyExemptionRequest>(`policyExemptionRequests/${id}`);
	}

	async create(model: SubmitPolicyExemptionRequest[]) {
		return this.post<PolicyExemptionRequest[]>(`policyExemptionRequests`, model)
	}

	async approve(id: number, model: { reason: string }) {
		return this.post<PolicyExemptionRequest>(`policyExemptionRequests/${id}/approval`, model);
	}

	async reject(id: number, model: { reason: string }) {
		return this.post<PolicyExemptionRequest>(`policyExemptionRequests/${id}/rejection`, model);
	}

}
